export default __webpack_public_path__ + "static/media/hht1_direction_songtime_02.eefe0c3d.jpg";